// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-components-post-template-js": () => import("./../src/components/PostTemplate.js" /* webpackChunkName: "component---src-components-post-template-js" */),
  "component---src-pages-index-js": () => import("./../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-posts-js": () => import("./../src/pages/posts.js" /* webpackChunkName: "component---src-pages-posts-js" */)
}

